import { RecipeVariants } from '@theme/utils/createRecipeObj';
import { createUseRecipeHook } from '@theme/utils/createUseRecipeHook';
import * as style from './CardGrid.css';

export const useCardGridStyle = createUseRecipeHook(style.root);

export type CardGridStyleProps = RecipeVariants<typeof style.root>;
